//0-25 indexes represent A-Z companies respectively
//index 26 is for special characters

const CompanyData = [
    ["Address Advisors","Adecco","Advantage Club","Agilite Technologies","Agumentik","Analog Devices","Amazon","ANR Software","Apporio lnfolabs","ATG","Attra lnfotech"],
    ["Bayer CropScience","Beetonz lnfotech","Bharat Electronics Ltd.","BNY Mellon"],
    ["Capgemini","Careerlvy","Carnation lnfotech","Cedcoss","Century Metal Recycling","Certybox","Chai Point","Chandigarh University","CHRYSO India Pvt Ltd","CIDC","Civil Guruji","Codevita (Digital)","CodeYoung","Coforge","Cognizant","Cogno Al","Congruex","Contaque","Core Card","Crimson Healthcare"],
    ["Daffodil Software", "Delhivery","Diversified Business Solutions Pvt. Ltd.", "DLT Labs","DRDO"],
    ["Edwisors","Effectual Services","Elitmus","Ericsson India Global Services","ETeam lnfoservices","Euthissa","Exposys Data Labs"],
    ["Firstnaukri","Freedom Employability Academy","FunctionApps"],
    ["Geetanjali Homestate","Gemini Solutions","Grapecity"],
    ["Hansa Solutions","HCL","Hevo Data","Hexaview Technologies","Hexaware","H-Town Technology","Humming Wave"],
    ["Identity & Access Solutions","India Glycols, Gida","lndiamart","Indus Towers","Infosys"],
    ["Jaro Education Group","Jio Platforms Ltd.","JTG Technology","Juspay"],
    ["Kl2  Techno Services Pvt. Ltd.","Keyideas","Kotak Mahindra Bank","Kinara Capital","Kloudrac Softwares","Knocial"],
    ["L&T Technology Services Ltd","L&T Construction Ltd","La Net Team Software Solutions","Learning Curve","Learning Routes","LeewayHertz","Logilite Technologies","Lohia Group","Lowe's India"],
    ["MG Motors","Microsoft","Mindtree","MosChip","Mtree Software"],
    ["Nagarro","NCR Corporation","Nuclei"],
    ["Oaktree Global","Omnepresent Technologies"],
    ["PakkaProfile","Paytm","PeopleStrong Technologies"," Pie lnfocomm","Pin Click"," Pianetspark","Prism Johnson Ltd.","Pulsus Health Group"],
    ["Qualitest","QSS Technosoft"],
    ["Radixweb","Revature"],
    ["Samsung SDS","Sarwan Technology","Scaler","Seekify","Skillvertex"," SmartBrains","SOTI","Siyaram","Step2gen","SYMB Technologies","Syscom"],
    ["Target Corporation","Tata Electronics Pvt. Ltd.","TCS","Tech Mahindra","Techciti Technologies","TechTammina","Tega Industries","The Hackett Group","Toshiba Software","TutorBin","Tycho Technologies"],
    ["UltraTech","Unthinkable Solutions"],
    ["Verifone","Velocitai","VM Coder Technology Solutions","Vodafone Idea Ltd"],
    ["Walmart","Wealth Clinic","Wipro"],
    ["X1","X2","X3","X4"],
    ["YHills Edutech"],
    ["Zensar"],
    ["6Wresearch"]
];

export default CompanyData;